import { render } from "./storyset.vue?vue&type=template&id=c3b58d1a&scoped=true"
import script from "./storyset.vue?vue&type=script&lang=js"
export * from "./storyset.vue?vue&type=script&lang=js"

import "./storyset.vue?vue&type=style&index=0&id=c3b58d1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3b58d1a"]])

export default __exports__